import { pillarSlug } from '../../lib/briefModel.js';

export default function BriefCategoryNav({ sections, className = '' }) {
  if (!sections?.length) return null;

  return (
    <nav
      aria-label="Brief categories"
      className={[
        'sticky top-0 z-20 bg-white/95 backdrop-blur border-y-[3px] border-black py-3 mb-8 -mx-4 px-4 sm:mx-0 sm:px-2',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-3 text-center">
        {sections.map((s, i) => (
          <span key={s.category} className="inline-flex items-center">
            {i > 0 ? (
              <span className="text-[#D4D4D4] px-1 select-none" aria-hidden="true">
                |
              </span>
            ) : null}
            <a
              href={`#${pillarSlug(s.category)}`}
              className="font-sans text-[12px] sm:text-[13px] font-bold tracking-[0.16em] uppercase text-black hover:text-[#C8351A] px-2.5 py-1.5 no-underline min-h-[44px] inline-flex items-center"
            >
              {s.category}{' '}
              <span className="font-mono text-[#C8351A]">{s.articles.length}</span>
            </a>
          </span>
        ))}
      </div>
    </nav>
  );
}
